import { Spinner } from "components/DesignSystem/Loader/loader";
import ToolTip from "components/design/toolTip";
import { DnDArea, UploadLabel } from "components/design/UploadFileSection";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { useModal } from "hooks/useModal";
import { useToast } from "hooks/useToast";
import { useImportPayrollMutation } from "store/apis/payroll";
import { BackendError } from "types/utils/error";
import PayrollJE from "./PayrollJE";

type ImportProps = {
  entityId: string;
};

export default function ImportModal({ entityId }: ImportProps) {
  const { alertToast } = useToast();
  const jeModal = useModal();
  const importModal = useModal();
  const [importPayroll, { isLoading, data }] = useImportPayrollMutation();

  const handleFileUpload = async (files: File[]) => {
    try {
      await importPayroll({ entityId, file: files[0] }).unwrap();
      jeModal.open();
      importModal.close();
    } catch (error) {
      alertToast(
        {
          message: (error as BackendError).data?.error?.message,
        },
        error as Error
      );
    }
  };
  return (
    <>
      <Modal.Root onOpenChange={importModal.toggle} open={importModal.isOpen}>
        <ToolTip text="Import reports from Gusto">
          <Modal.Trigger asChild>
            <Button customType="primary" size="xsmall">
              Import
            </Button>
          </Modal.Trigger>
        </ToolTip>
        <Modal.Content size="large">
          <Modal.Header>
            <Modal.Title>Import report from Gusto</Modal.Title>
            <Modal.Close />
          </Modal.Header>

          <Modal.Body className="t-flex t-flex-col t-gap-5">
            {isLoading ? (
              <div className="t-flex t-flex-col t-items-center t-justify-center t-gap-4 t-h-60">
                <Spinner />
                <div className="t-text-center t-flex t-flex-col t-gap-2">
                  <span className="t-text-subtext t-text-text-60">
                    Processing payroll report
                  </span>
                  <p className="t-text-body-sm t-text-text-30">
                    Securely importing your data
                  </p>
                </div>
              </div>
            ) : (
              <>
                <div>
                  <UploadLabel>
                    Download the payroll summary from Gusto and upload directly
                  </UploadLabel>
                  <DnDArea
                    multiple={false}
                    onDrop={handleFileUpload}
                    accept={{ "text/csv": [".csv"] }}
                    title="Click or drag and drop to upload the payroll report"
                    subText="File Format: csv"
                  />
                </div>
              </>
            )}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
      <PayrollJE
        isOpen={jeModal.isOpen}
        close={jeModal.close}
        jeData={data}
        entityId={entityId}
      />
    </>
  );
}
